import { AngularSvgIconModule } from "angular-svg-icon";

import { ChangeDetectionStrategy, Component, computed, input, linkedSignal, model, output } from "@angular/core";

export type SafeButtonStyle = "primary" | "secondary" | "red";

@Component({
  selector: "safe-button",
  templateUrl: "./safe-button.html",
  styleUrl: "./safe-button.scss",
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [AngularSvgIconModule],
})
export class SafeButton {
  disabled = input(false);
  small = input(false);
  btnStyle = input<SafeButtonStyle>("primary");
  loaderAfterClick = input(false);
  public _enabled = linkedSignal(() => !this.disabled());

  clicked = output<MouseEvent>();

  loading = model(false);

  // handle disabled state without changing the input value
  protected buttonClass = computed(() => {
    const cls = ["button", `button--${this.btnStyle()}`];
    if (this.small()) cls.push("button--small");
    return cls.join(" ");
  });

  protected onClickButton(event: MouseEvent) {
    event.stopPropagation();
    if (this._enabled()) {
      this._enabled.set(false);
      this.clicked.emit(event);
      if (this.loaderAfterClick()) {
        this.loading.set(true);
      }
    }
  }
}
